module.exports = __webpack_public_path__ + "static/media/DqEveryChildChallengeHero.23aa5b37.jpg";